import { motion } from 'framer-motion';

import { ReactComponent as AlertTriangle } from '../../../images/assessment/alertTriangle.svg';

function ScoreCircle({ extraStyling }) {
    //This SVG will return a static image, rather than using their assessment score
    return (
        <div className={`w-[80px] items-center relative ${extraStyling}`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80">
                <circle
                    cx="40"
                    cy="40"
                    r="35"
                    stroke="#f45723"
                    strokeOpacity={0.2}
                    strokeWidth="10"
                    fill="transparent"
                />
                <circle
                    cx="40"
                    cy="40"
                    r="35"
                    stroke="#f45723"
                    strokeWidth="10"
                    fill="transparent"
                    strokeDasharray={2 * Math.PI * 36}
                    strokeDashoffset={2 * Math.PI * 36 * 0.2}
                    style={{
                        transition: 'stroke-dashoffset 0.5s',
                        transform: 'rotate(-90deg)',
                        transformOrigin: '40px 40px',
                    }}
                />
            </svg>
            <AlertTriangle className="absolute-center h-[20px] w-[20px]" fill="red-assessment" />
        </div>
    );
}
export default ScoreCircle;
